import axios from "axios"
import { DEFAULT_TENANT_ID } from "shared/utils/tenantContext"

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, "")}${path}`
  }
  return path
}

export interface PagedResultDto<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export interface UserRoleAssignmentDto {
  userRoleId: string
  tenantId: string
  userId: string
  employeeId?: string | null
  fullName?: string | null
  username?: string | null
  email?: string | null
  roleId: string
  roleCode?: string | null
  roleName?: string | null
  departmentId?: string | null
  departmentCode?: string | null
  departmentName?: string | null
  isActive: boolean
  validFrom?: string | null
  validTo?: string | null
}

export interface UserRoleAssignmentSearchParams {
  tenantId?: string
  roleId?: string
  departmentId?: string
  roleIds?: string[]
  departmentIds?: string[]
  search?: string
  isActive?: boolean
  page?: number
  pageSize?: number
}

export interface CreateUserRoleAssignmentRequest {
  tenantId?: string
  userId: string
  roleId: string
  departmentId?: string | null
}

export interface UpdateUserRoleAssignmentRequest {
  tenantId?: string
  roleId: string
  departmentId?: string | null
  isActive: boolean
}

export async function searchUserRoleAssignments({
  tenantId = DEFAULT_TENANT_ID,
  roleId,
  departmentId,
  roleIds,
  departmentIds,
  search,
  isActive,
  page = 1,
  pageSize = 20,
}: UserRoleAssignmentSearchParams): Promise<PagedResultDto<UserRoleAssignmentDto>> {
  const response = await axios.get<PagedResultDto<UserRoleAssignmentDto>>(buildUrl("/api/v1/roles/user-assignments"), {
    params: {
      tenantId,
      roleId,
      departmentId,
      roleIds,
      departmentIds,
      search,
      isActive,
      page,
      pageSize,
    },
    paramsSerializer: (requestParams) => {
      const urlParams = new URLSearchParams()
      Object.entries(requestParams).forEach(([key, value]) => {
        if (value === undefined || value === null) {
          return
        }
        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (item !== undefined && item !== null) {
              urlParams.append(key, String(item))
            }
          })
          return
        }
        urlParams.append(key, String(value))
      })
      return urlParams.toString()
    },
  })
  return response.data
}

export async function createUserRoleAssignment(
  payload: CreateUserRoleAssignmentRequest,
): Promise<UserRoleAssignmentDto> {
  const response = await axios.post<UserRoleAssignmentDto>(buildUrl("/api/v1/roles/user-assignments"), payload)
  return response.data
}

export async function updateUserRoleAssignment(
  userRoleId: string,
  payload: UpdateUserRoleAssignmentRequest,
): Promise<UserRoleAssignmentDto> {
  const response = await axios.post<UserRoleAssignmentDto>(
    buildUrl(`/api/v1/roles/user-assignments/${userRoleId}`),
    payload,
  )
  return response.data
}
